import * as React from "react";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CorrectionItem = ({ recordId, title, description, isDisabled, onClick, onRemove, correctionSelected }) => {
    return (
        <li
            className="col-md-6"
            data-automationid={`${title}-posh-select`}
            style={{ paddingLeft: 5 + "px", paddingRight: 5 + "px" }}
            onClick={(e) => { if (isDisabled) return null; else {e.preventDefault(); onClick(e)} }}>
            <input type="radio" name={`${title}${recordId}`} value="true" checked={correctionSelected} readOnly disabled={isDisabled} />
            <label>
                <span className="posh-select-icon"><FontAwesomeIcon icon={faPenToSquare} aria-hidden="true" /></span>
                <span className="posh-select-body">
                    <span className="posh-select-title">{title}</span>
                    <div className="row">
                        <div className="col-md-10">
                            <span className="posh-select-description text-muted">{description}</span>
                        </div>
                        <div className="col-md-2">
                            {correctionSelected ? <button className="btn btn-primary btn-outline pull-right" onClick={(e) => { e.stopPropagation(); onRemove() }}>Remove</button> : null}
                        </div>
                    </div>
                </span>
            </label>
        </li>
    )
}
